import type { BreadcrumbEventData } from '../types';

export class Breadcrumbs {
  private trail: BreadcrumbEventData[] = [];

  constructor(private maxSize: number = 50) {}

  add(
    category: BreadcrumbEventData['category'],
    message: string,
    data?: Record<string, unknown>
  ): void {
    const crumb: BreadcrumbEventData = { category, message };
    if (data) crumb.data = data;
    this.trail.push(crumb);
    if (this.trail.length > this.maxSize) {
      this.trail = this.trail.slice(-this.maxSize);
    }
  }

  getTrail(): BreadcrumbEventData[] {
    return [...this.trail];
  }

  clear(): void {
    this.trail = [];
  }
}
